import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm mb-4 md:mb-0">
            © {currentYear} - {currentYear + 1} Get Foxy Social Media
          </p>
          <p className="text-gray-500 text-sm">
            Powered by Webador
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;